import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const MinusIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19 13H5V11H19V13Z'
                fill='currentColor'
            />
        </>
    ),
})

MinusIcon.displayName = 'MinusIcon'
